module.exports = __webpack_public_path__ + "e1656cf8fab2578dfab3fa6af49cb0c5.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/head/mystirio.jpg
// module id = 493
// module chunks = 0